import { render } from "./HowToWearV2.vue?vue&type=template&id=63392344&scoped=true"
import script from "./HowToWearV2.vue?vue&type=script&lang=js"
export * from "./HowToWearV2.vue?vue&type=script&lang=js"

import "./HowToWearV2.vue?vue&type=style&index=0&id=63392344&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63392344"]])

export default __exports__